"use client";
import {
  CRUDFetchParams,
  DataListParams,
  DataListProp,
  DataParams,
  LayoutProps,
  TransitionType,
} from "@/components/layout/layoutType";
import * as dc from "@/components/layout/list/defaultType";
import dayjs from "dayjs";
import { RoastingResult } from "./roaster/RoastingResult";
import { SettingResult } from "./setting/SettingResult";
import { CafeResult } from "./cafe/CafeResult";
import { RoasterItem } from "./roaster/RoasterItem";
import { RoasterGreenbean } from "./roaster/RoasterGreenbean";
import { SystemResult } from "./setting/SystemResult";
import { Debug } from "@/util/debug";
import { BlendingResult } from "./roaster/BlendingResult";
import { RoasterQC } from "./roaster/RoasterQC";
import { RoasterEtc } from "./roaster/RoasterEtc";
import { CafeEtc } from "./cafe/CafeEtc";
import { EventLink } from "./user/EventLink";
import { BeanInfo } from "./user/BeanInfo";
import { BrewingInfo } from "./user/BrewingInfo";
import { CafeCoffeebean } from "./cafe/CafeCoffeebean";
import { CafeItem } from "./cafe/CafeItem";
import { CafeMenu } from "./cafe/CafeMenu";
import { RoasterMenu } from "./roaster/RoasterMenu";
import { InfoIntro } from "./user/InfoIntro";
import { UserChart } from "./user/UserChart";
import { CafeSupplier } from "./cafe/CafeSupplier";
import { RoasterCafe } from "./roaster/RoasterCafe";
import { CafeBrewing } from "./cafe/CafeBrewing";
import { UserItem } from "./user/UserItem";
import { UserBrewing } from "./user/UserBrewing";
import { CafeQC } from "./cafe/CafeQC";
import { UserQC } from "./user/UserQC";
import { CafeBeanInfo } from "./cafe/CafeBeanInfo";
// import dynamic from "next/dynamic";
// const exportElementAsPNG = dynamic(() => import("html-to-image").then((mod) => mod.), { ssr: false });

//
//const dv = require("@datas/default.json");

export function getDataListProp(props: DataListProp): DataListParams | undefined {
  const t = props.t;
  const ta = props.ta;
  const params = props.params;
  const form = props.form;
  const formMemo = props.formMemo;
  const setValueList = props.setValueList;
  const setSubData = props.setSubData;
  const formFunction = props.formFunction;
  const dataFunction = props.dataFunction;

  const emptyFetch: CRUDFetchParams = { fetchUrl: "" };
  const result: DataListParams = {
    user: params?.user,
    page: params?.page,
    locale: params?.locale,
    pathname: params?.menu?.pathname,
    dataFetch: emptyFetch,
    listFetch: emptyFetch,
    alertFunction: params?.alertFunction,
    pageAuth: params?.pageAuth,
    setTimer: params?.setTimer,
  };
  const utcOffset = dayjs().utcOffset() * 60000;

  //const result_params = { t, ta, result, params, form, formMemo, setValueList, formFunction, dataFunction };
  const result_params = { ...props, result };
  // Debug("page info", params?.page, params?.page.case);
  if (params?.page.case) {
    switch (params.page.case) {
      case "InfoIntro":
        return InfoIntro(result_params);
      case "UserChart":
        return UserChart(result_params);
      case "UserQC":
        return UserQC(result_params);
      case "UserBrewing":
        return UserBrewing(result_params);
      case "UserItem":
        return UserItem(result_params);
      case "BeanInfo":
        return BeanInfo(result_params);
      case "BrewingInfo":
        return BrewingInfo(result_params);
      case "EventLink":
        return EventLink(result_params);
      case "CafeBrewing":
        return CafeBrewing(result_params);
      case "CafeQC":
        return CafeQC(result_params);
      case "CafeCoffeebean":
        return CafeCoffeebean(result_params);
      case "CafeBeanInfo":
        return CafeBeanInfo(result_params);
      case "CafeItem":
        return CafeItem(result_params);
      case "CafeMenu":
        return CafeMenu(result_params);
      case "CafeSupplier":
        return CafeSupplier(result_params);
      case "CafeEtc":
        return CafeEtc(result_params);
      case "RoastingResult":
        return RoastingResult(result_params);
      case "BlendingResult":
        return BlendingResult(result_params);
      case "RoasterQC":
        return RoasterQC(result_params);
      case "RoasterMenu":
        return RoasterMenu(result_params);
      case "RoasterGreenbean":
        return RoasterGreenbean(result_params);
      case "RoasterItem":
        return RoasterItem(result_params);
      case "RoasterCafe":
        return RoasterCafe(result_params);
      case "RoasterEtc":
        return RoasterEtc(result_params);
      case "SettingSystem":
        return SystemResult(result_params);
      default:
        return undefined;
    }
  } else {
    switch (params?.page.page ?? "") {
      case "CafeSettingToday":
      case "CafeSettingDefault":
      case "CafeSettingHistory":
      case "CafeSettingNote":
        return CafeResult(result_params);
      case "CafeCreate":
        return {
          ...result,
          dataName: "CafeCreate",
          dataFetch: {
            saveFetch: {
              fetchUrl: "/api/cafe/create",
              successFunction: () => {
                if (sessionStorage !== undefined) {
                  sessionStorage.removeItem("cafe_auth");
                }
                return "/cafe";
              },
            },
          }, //
          useList: false,
          useDefaultId: true,
          defaultMode: "write",
          dataCols: {
            cafe_type: { ...dc.select, codeGroup: "CAFE", required: true, defaultValue: "PRV" },
            cafe_country: {
              ...dc.selectSearch,
              required: true,
              inputClassName: dc.inputCountryClassName,
              codeGroup: "CNTR",
              defaultValue: "KOR",
            },
            cafe_name_locale: { ...dc.inputFull, required: true, minLength: 3, maxLength: 300, showCount: true },
            cafe_name: { ...dc.inputFull, required: true, minLength: 3, maxLength: 300, showCount: true },
            cafe_detail: { ...dc.textArea },
            //coffee_vrt: { ...dc.selectSearchMulti, codeGroup: "VRT", codeGroupLabel: "feat", inputClassName: dc.inputCountryClassName },
          },
          saveButtonTitle: "create",
          saveButtonIcon: { iconName: "Coffee", iconType: "phosphor" },
          cancelButtonFunction: "/cafe",
        };
      case "RoasterCreate":
        return {
          ...result,
          dataName: "RoasterCreate",
          dataFetch: {
            saveFetch: {
              fetchUrl: "/api/roaster/create",
              successFunction: () => {
                if (sessionStorage !== undefined) {
                  sessionStorage.removeItem("roaster_auth");
                }
                return "/roaster";
              },
            },
          },
          useList: false,
          useDefaultId: true,
          defaultMode: "write",
          dataCols: {
            roaster_type: { ...dc.select, codeGroup: "RSTR", defaultValue: "PRV" },
            roaster_country: {
              ...dc.selectSearch,
              inputClassName: dc.inputCountryClassName,
              codeGroup: "CNTR",
              defaultValue: "KOR",
            },
            roaster_name_locale: { ...dc.inputFull, required: true, minLength: 3, maxLength: 300, showCount: true },
            roaster_name: { ...dc.inputFull, required: true, minLength: 3, maxLength: 300, showCount: true },
            roaster_detail: { ...dc.textArea },
          },
          saveButtonTitle: "create",
          saveButtonIcon: { iconName: "Factory", iconType: "phosphor" },
          cancelButtonFunction: "/roaster",
        };
      case "CafeUserInfo":
      case "RoasterUserInfo":
      case "UserBasicInfo":
      case "Country":
      case "SettingRegion":
      case "SettingFarm":
      case "CodeGroup":
      case "CodeList":
      case "Variety":
      case "SettingEquip":
      case "SettingMaterial":
      case "SettingGreenbeanDefault":
      case "SettingGreenbeanYear":
      case "SettingCompany":
      case "SettingRoaster":
      case "SettingCafe":
        return SettingResult(result_params);

      case "Farm":
      default:
        return undefined;
    }
  }
}
